export const { BASE_URL } = process.env
export const API_TIMEOUT = Number(process.env.API_TIMEOUT) || 30000
export const API_PREFIX = '/api/v1'
export const SECRET_KEY = process.env.SECRET_KEY || ''
export const NODE_ENV = process.env.NODE_ENV || 'development'
